import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/edit-01.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M16.2929 2.2928C17.788 0.797899 20.2119 0.797917 21.707 2.2928C23.202 3.78785 23.202 6.21176 21.707 7.70686L8.50095 20.9139C8.23514 21.1797 8.00727 21.4139 7.73337 21.5946C7.50773 21.7433 7.26295 21.8609 7.00583 21.9442C6.69374 22.0452 6.36863 22.0765 5.99509 22.118L2.61032 22.494C2.30842 22.5275 2.00773 22.4217 1.79294 22.2069C1.57823 21.9921 1.47229 21.6913 1.50583 21.3895L1.8818 18.0057C1.92332 17.632 1.95457 17.3062 2.05563 16.994C2.13888 16.7369 2.25744 16.492 2.40622 16.2664C2.58682 15.9927 2.82116 15.7646 3.08688 15.4989L16.2929 2.2928ZM20.2929 3.70686C19.5789 2.99303 18.421 2.99301 17.707 3.70686L4.50095 16.9139C4.17854 17.2363 4.11815 17.3028 4.07516 17.368C4.02567 17.4431 3.98667 17.5246 3.95895 17.6102C3.9349 17.6845 3.92045 17.7731 3.87009 18.2264L3.6318 20.368L5.77438 20.1307C6.22716 20.0804 6.31536 20.0649 6.38962 20.0408C6.47534 20.0131 6.55756 19.9742 6.63278 19.9246C6.69788 19.8817 6.7649 19.8208 7.08688 19.4989L20.2929 6.2928C21.0068 5.57874 21.0069 4.42086 20.2929 3.70686Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as Edit01Icon };
